import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				link: "closeMenu",
				button: "handleBurgerClick",
			},
			keydown: {
				parent: "handleKeydown",
			},
		};

		this.parentLinks = this.el.querySelectorAll('[data-navigation="parent"] > a');
	}

	init() {
		console.log("Header module initialized.");
	}

	handleBurgerClick(e) {
		if (document.body.classList.contains("-menu-open")) {
			this.closeMenu();
		} else {
			document.body.classList.add("-menu-open");
			//this.call?.("open", "overlay");
			window.dispatchEvent(new CustomEvent("lenisToggle", { detail: { status: "stopped" } }));
		}
	}

	closeMenu() {
		if (document.body.classList.contains("-menu-open")) {
			document.body.classList.remove("-menu-open");
			window.dispatchEvent(new CustomEvent("lenisToggle", { detail: { status: "started" } }));
		}
	}

	handleParentClick(e) {
		const parentLink = e.target;

		// Check if the clicked element is an <a> tag and has the aria-haspopup="true" attribute.
		if (parentLink.tagName === "A" && parentLink.getAttribute("aria-haspopup") === "true") {
			e.preventDefault();

			const isExpanded = parentLink.getAttribute("aria-expanded") === "true";

			this.parentLinks.forEach((link) => {
				if (link !== parentLink && link.getAttribute("aria-expanded") === "true") {
					link.setAttribute("aria-expanded", "false");
					link.nextElementSibling.classList.remove("is-open");
				}
			});

			parentLink.setAttribute("aria-expanded", !isExpanded);
			parentLink.nextElementSibling.classList.toggle("is-open");
		}
	}

	handleKeydown(e) {
		const parentLi = e.target.closest('[data-navigation="parent"]');
		const parentLink = e.target.closest("a");

		// Find the parent link whose sub-menu is currently open.
		const openLink = this.el.querySelector('[aria-expanded="true"]');

		// Close the menu if the Escape key is pressed while any part of the menu is active.
		if (e.key === "Escape" && openLink) {
			e.preventDefault();
			openLink.setAttribute("aria-expanded", "false");
			const submenu = openLink.closest('[data-navigation="parent"]').querySelector(".c-header_submenu");
			if (submenu) {
				submenu.classList.remove("is-open");
			}
			openLink.focus();
		}

		// Handle Enter/Space to open the dropdown
		if (parentLi && parentLink.getAttribute("aria-haspopup") === "true") {
			if (e.key === "Enter" || e.key === " ") {
				e.preventDefault();
				const isExpanded = parentLink.getAttribute("aria-expanded") === "true";
				parentLink.setAttribute("aria-expanded", !isExpanded);
				console.log("parentLink.nextElementSibling", parentLink.nextElementSibling);
				parentLink.nextElementSibling.classList.toggle("is-open");
			}
		}
	}

	destroy() {}
}
